import { tabsAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

var multiStyleConfig = createMultiStyleConfigHelpers(tabsAnatomy.keys);

var definePartsStyle = multiStyleConfig.definePartsStyle;
var defineMultiStyleConfig = multiStyleConfig.defineMultiStyleConfig;

var baseStyle = definePartsStyle({
  tab: {
    fontFamily: `"AeonikPro", sans-serif`,
  },
});

export var tabsTheme = defineMultiStyleConfig({
  baseStyle: baseStyle,
});
